<template>
    <footer class="footer">
        <div class="footer-wrap">
            <router-link  to="/" class="footer__logo"><img :src="require('@/assets/logo-white.svg')" alt=""></router-link>
            <div class="footer__info">
                <ul class="footer__list">
                    <li class="footer__item" v-for="(menu,i) in menuList" :key="i">
                        <router-link class="footer__link" :to="menu.url">{{ menu.title[$i18n.locale] }}</router-link>
                    </li>
                </ul>
                <div v-if="false">
                    <button class="button button-live-chat">
                        <img class="button-live-chat__icon" :src="require('@/assets/chat.svg')" alt="chat">
                        {{$t('buttons.Live Chat')}}
                    </button>
                </div>
            </div>
        </div>
    </footer>
    <div class="copyright">
        <div class="footer-wrap copyright__wrap">
            <p class="copyright__text">{{ $t('Copyright.text') }}</p>
            <div class="copyright__right">
                <ul class="list_of_agreements">
                    <li class="list_of_agreements__item"
                        v-for="(item, i) in list_of_agreements"
                        :key="i"
                        :class="item.icon"
                    >
                        <span class="list_of_agreements__item__badge"></span>
                        <a :href="item.url" :target="item.target"> {{ item.text }}</a>
                    </li>
                </ul>
                <ul class="copyright__list">
                    <li class="copyright__item">
                        <a href="https://www.facebook.com/share/18SwMDkqqR/?mibextid=wwXIfr" target="_blank" title="facebook">
                            <i class="fa-brands fa-facebook-f"></i>
                        </a>
                    </li>
                    <li class="copyright__item">
                        <a href="https://www.linkedin.com/company/prometheuspro" target="_blank" title="linkedin">
                            <i class="fa-brands fa-linkedin-in"></i>
                        </a>
                    </li>
                    <!-- <li class="copyright__item"><a href="https://www.instagram.com/login"><i class="fa-brands fa-instagram"></i></a></li>    -->
                    <!-- <li class="copyright__item"><a href="https://twitter.com/i/flow/login?input_flow_data=%7B%22requested_variant%22%3A%22eyJsYW5nIjoicnUifQ%3D%3D%22%7D"><i class="fa-brands fa-twitter"></i></a></li>-->
                    <!-- <li class="copyright__item"><a href="https://www.youtube.com/"><i class="fa-brands fa-youtube"></i></a></li>-->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FooterComponent",
    data(){
        return{
            list_of_agreements: [
                {
                    text: 'Privacy Policy',
                    url: '/privacy',
                    icon: 'policy',
                    target:"_blank"
                },
                {
                    text: 'Return Policy',
                    url: 'https://app.termly.io/policy-viewer/policy.html?policyUUID=9549a175-0a5d-453e-b01b-3d6fd670d7cd',
                    icon: 'policy',
                    target:"_blank"
                },
                {
                    text: 'Cookies Policy',
                    url: 'https://app.termly.io/policy-viewer/policy.html?policyUUID=c689b2ad-aafa-445f-a30b-b209db79cef9',
                    icon: 'cookies',
                    target:"_blank"
                },
                {
                    text: 'Terms & Conditions',
                    url: '/terms',
                    icon: 'terms',
                    target:"_blank"
                }
            ],
            menuList:[
                {
                    title: {
                        en: "xTrack",
                        es: "xTrack",
                        pt: "xTrack",
                    },
                    url:"/product/xtrack"
                },
                {
                    title: {
                        en: "xTrack Assets",
                        es: "xTrack Assets",
                        pt: "xTrack Assets",
                    },
                    url:"/product/xtrack-assets"
                },
                {
                    title: {
                        en: "ProVision",
                        es: "ProVision",
                        pt: "ProVision",
                    },
                    url:"/product/provision"
                },

                {
                    title: {
                        en: "xCool",
                        es: "xCool",
                        pt: "xCool",
                    },
                    url:"/product/xcool"
                },
                {
                    title: {
                        en: "xCargo",
                        es: "xCargo",
                        pt: "xCargo",
                    },
                    url:"/product/xcargo"
                },
                {
                    title: {
                        en: "xCargo Vision",
                        es: "xCargo Vision",
                        pt: "xCargo Vision",
                    },
                    url:"/product/xcargo-vision"
                },
                {
                    title: {
                        en: "xELD",
                        es: "xELD",
                        pt: "xELD",
                    },
                    url:"/product/xeld"
                },
                {
                    title: {
                        en: "xApps",
                        es: "xApps",
                        pt: "xApps",
                    },
                    url:"/product/xapps"
                },
                // {
                //     title: {
                //         en: "Privacy Policy",
                //         es: "Privacy Policy",
                //         pt: "Privacy Policy",
                //     },
                //     url:"/product/privacy_policy"
                // },
                // {
                //     title: {
                //         en: "Privacy Policy",
                //         es: "Privacy Policy",
                //         pt: "Privacy Policy",
                //     },
                //     url:"/privacy-policy"
                // }
            ],
        }
    }
}
</script>

<style scoped>
.footer,
.copyright {
    position: relative;
    z-index: 1;
}

</style>